import { render, staticRenderFns } from "./vendor-details-working-hours.vue?vue&type=template&id=6d30e8aa&scoped=true"
import script from "./vendor-details-working-hours.vue?vue&type=script&lang=js"
export * from "./vendor-details-working-hours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d30e8aa",
  null
  
)

export default component.exports